import React from 'react';
import CombinedCharacteristics from "./charLayout_combined";
import InputRow from "../../../pages/pageParts/inputForms/inputRow"
import InputText from "../../../pages/pageParts/inputForms/inputText";

export const renderer = (tBallot, allPoints, ballot, locked, content) => {
    const decision = tBallot.bConfig.roles.find(x => x[0] === content.decision);
    const charCount = content.comments ? content.comments.length : 0

    return (<>
        <div className="row">
            <div className="col-lg-6 col-12">
                {ballot && ballot.competitors.filter(x => x.role === tBallot.bConfig.roles[0][1]).map((competitor, index) => {
                    return (
                        <CombinedCharacteristics key={index} updateContents={tBallot.onUpdateContents}
                            competitor={competitor}
                            content={competitor.content}
                            rankCount={ballot.competitors.length}
                            allPoints={allPoints}
                            readOnly={locked}
                            options={tBallot.bConfig.characteristics}
                        />
                    )
                })
                }
            </div>

            <div className="col-lg-6 col-12">
                {ballot && ballot.competitors.filter(x => x.role === tBallot.bConfig.roles[1][1]).map((competitor, index) => {
                    return (
                        <CombinedCharacteristics key={index} updateContents={tBallot.onUpdateContents}
                            competitor={competitor}
                            content={competitor.content}
                            rankCount={ballot.competitors.length}
                            allPoints={allPoints}
                            readOnly={locked}
                            options={tBallot.bConfig.characteristics}
                        />
                    )
                })
                }
            </div>
        </div>

        <div className="row align-self-center text-center">
            <div className="col-12">
                <InputRow disabled={locked} type="radio" name="decision" title="Decision"
                    value={content.decision} options={tBallot.bConfig.roles}
                    onChange={tBallot.onBallotChange}
                />
                {decision && <h4>{`${decision[1]} Wins`}</h4>}
            </div>
        </div>

        <div className="row align-self-center text-center">
            <div className="col-lg-12 col-sm-12">
                <InputText
                    readOnly={locked} rows={8} style={{ color: "slate", fontSize: "20px" }}
                    label="Reason for Decision and other comments: (It is very helpful for the competitors if you enter at least 100 characters)"
                    labelSuffix={<span className={charCount >= 100 ? "font-success" : "font-danger"}>[{charCount}&nbsp;characters]</span>}
                    id="comments" value={content.comments} onChange={tBallot.onBallotChange} placeholder="" autoResize />
            </div>
        </div>

    </>)
}
